import { useFormContext } from 'react-hook-form';

import { FormBlock } from '@/widgets/ServiceFormTemplate/ui/FormBlock';

import { MultipleWeaponSelectionSchema } from '@/features/ui/Steps/MultipleWeaponSelection/model/types';
import { WeaponSelectionSchema } from '@/features/ui/Steps/WeaponSelection/model/types';

import { FormSelect, Informer } from '@/shared/ui';

import { OrgNpuOption } from '@/api/types';

type NpuFormFields = WeaponSelectionSchema | MultipleWeaponSelectionSchema;

export const NpuFormBlock: React.FC<{ orgNpuOptions: OrgNpuOption[] }> = ({ orgNpuOptions }) => {
  const { control, watch } = useFormContext<NpuFormFields>();
  const npu = watch('orgNpu');

  return (
    <FormBlock title="Орган НПУ">
      <FormSelect
        name="orgNpu"
        control={control}
        label="Орган НПУ, до якого надсилається заявка"
        required
        options={orgNpuOptions}
      />
      {npu && !npu.isPayable && (
        <Informer
          className="confirmation-orgnpu-informer"
          icon={{
            name: 'attention',
            color: 'red',
          }}
          header={{
            text: 'Зверніть увагу!',
            color: 'red',
          }}
          text={{
            color: 'black',
            text: 'Для цього органу НПУ тимчасово відсутня можливість оплати послуги онлайн. Для того щоб подати цю заявку вам доведеться оплатити послугу будь-яким іншим способом та прикріпити квитанцію про платіж на кроці оплати.',
          }}
        />
      )}
    </FormBlock>
  );
};
